<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="dbBackup">
  <div class="row m-0 col-md-12  formborder">
    <!-- <div class="col-md-12 mt-4">
    <button
      type="button"
      (click)="onBackup()"
      class="btn font-size-12 button-btn"
    >
       Backup
    </button>

    <button
      type="button"
      (click)="onDBAndDocBackup()"
      class="btn font-size-12 button-btn"
    >
      Database And Doc Backup
    </button>
  </div> -->

    <div class="row m-0" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <div class="col-md-10 p-1">
        <span class="required-lable"> Login Id </span>
        <input
          required
          type="text"
          #refDbLoginId="ngModel"
          [(ngModel)]="DbLoginId"
          placeholder="DB Login ID"
          name="DbLoginId"
          id="DbLoginId"
          class="form-control input-text-css"
          [ngClass]="{
            'is-invalid': f.submitted && refDbLoginId.invalid,
            'alert-warning':
              refDbLoginId.invalid &&
              (refDbLoginId.dirty ||
                refDbLoginId.touched ||
                refDbLoginId.untouched)
          }"
        />
      </div>
    </div>
    <div class="row m-0" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <div class="col-md-10 p-1">
        <span class="required-lable"> Login Password </span>
        <input
          required
          type="password"
          #refDbLoginPass="ngModel"
          [(ngModel)]="DbLoginPass"
          placeholder="DB Login Password"
          name="DbLoginPass"
          id="DbLoginPass"
          class="form-control input-text-css"
          [ngClass]="{
            'is-invalid': f.submitted && refDbLoginPass.invalid,
            'alert-warning':
              refDbLoginPass.invalid &&
              (refDbLoginPass.dirty ||
                refDbLoginPass.touched ||
                refDbLoginPass.untouched)
          }"
        />
      </div>
    </div>
    <!--<div class="row m-0" style="width: 100%; font-weight: bold;" >
             <mat-checkbox
                name="DocDownload"
                [(ngModel)]="DocDownload"
                class="mt-3"
               >
                Attachments & document files 
              </mat-checkbox>
              
          </div>-->
    <div class="row m-0" style="width: 100%;  color: red; font-weight: bold; display: flex; justify-content: center; align-items: center;">
      <div class="col-md-10 p-1">
      <p class="m-0">
        <span>* </span>Please ensure that this backup contains data files.
      </p>
      <p class="m-0">
        <span>* </span>Attachments & document files are not included.
      </p>
      </div>
    </div>
    <div class="row m-0 pl-3" style="display: flex; justify-content: center; align-items: center;">
      <div class="col-md-12 mt-4">
        <button
          type="button"
          [disabled]="!f.form.valid"
          (click)="onDbAndDocBackup()"
          class="btn font-size-12 button-btn"
        >
          Download Backup File
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade in"
  id="BackupModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #f="ngForm" (ngSubmit)="onBackupSubmit()" novalidate>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        class="modal-content formborder"
      >
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Backup Details
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div class="row m-0" style="width: 100%">
            <div class="col-md-10 p-1">
              <span class="required-lable"> DB Login Id </span>
              <input
                required
                type="text"
                #refDbLoginId="ngModel"
                [(ngModel)]="DbLoginId"
                placeholder="DB Login ID"
                name="DbLoginId"
                id="DbLoginId"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': f.submitted && refDbLoginId.invalid,
                  'alert-warning':
                    refDbLoginId.invalid &&
                    (refDbLoginId.dirty ||
                      refDbLoginId.touched ||
                      refDbLoginId.untouched)
                }"
              />
            </div>
          </div>
          <div class="row m-0" style="width: 100%">
            <div class="col-md-10 p-1">
              <span class="required-lable"> DB Login Password </span>
              <input
                required
                type="password"
                #refDbLoginPass="ngModel"
                [(ngModel)]="DbLoginPass"
                placeholder="DB Login Password"
                name="DbLoginPass"
                id="DbLoginPass"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': f.submitted && refDbLoginPass.invalid,
                  'alert-warning':
                    refDbLoginPass.invalid &&
                    (refDbLoginPass.dirty ||
                      refDbLoginPass.touched ||
                      refDbLoginPass.untouched)
                }"
              />
            </div>
          </div>
          <div
            class="row m-0"
            style="width: 100%; color: red; font-weight: bold"
          >
            <p class="m-0">
              <span>* </span>Please ensure that this backup contains data files.
            </p>
            <p class="m-0">
              <span>* </span>Attachments & document files are not included.
            </p>
          </div>

          <div class="row m-0 pr-4" style="float: right">
            <div class="col-md-12 mt-4">
              <button
                type="button"
                [disabled]="!f.form.valid"
                (click)="onBackupSubmit()"
                class="btn font-size-12 button-btn"
              >
                Download Database Backup File
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div
  class="modal fade in"
  id="BackupDBDocModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #f="ngForm" (ngSubmit)="onBackupSubmit()" novalidate>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        class="modal-content formborder"
      >
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Backup Details
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div class="row m-0" style="width: 100%">
            <div class="col-md-10 p-1">
              <span class="required-lable"> Login Id </span>
              <input
                required
                type="text"
                #refDbLoginId="ngModel"
                [(ngModel)]="DbLoginId"
                placeholder="DB Login ID"
                name="DbLoginId"
                id="DbLoginId"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': f.submitted && refDbLoginId.invalid,
                  'alert-warning':
                    refDbLoginId.invalid &&
                    (refDbLoginId.dirty ||
                      refDbLoginId.touched ||
                      refDbLoginId.untouched)
                }"
              />
            </div>
          </div>
          <div class="row m-0" style="width: 100%">
            <div class="col-md-10 p-1">
              <span class="required-lable"> Login Password </span>
              <input
                required
                type="password"
                #refDbLoginPass="ngModel"
                [(ngModel)]="DbLoginPass"
                placeholder="DB Login Password"
                name="DbLoginPass"
                id="DbLoginPass"
                class="form-control input-text-css"
                [ngClass]="{
                  'is-invalid': f.submitted && refDbLoginPass.invalid,
                  'alert-warning':
                    refDbLoginPass.invalid &&
                    (refDbLoginPass.dirty ||
                      refDbLoginPass.touched ||
                      refDbLoginPass.untouched)
                }"
              />
            </div>
          </div>

          <div class="row m-0 pr-4" style="float: right">
            <div class="col-md-12 mt-4">
              <button
                type="button"
                [disabled]="!f.form.valid"
                (click)="onDbAndDocBackup()"
                class="btn font-size-12 button-btn"
              >
                Download Backup File
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
